// Module
var code = "<template>\n    <div class=\"card card--full import-entry-heading-card\">\n        <div class=\"card-inner\">\n            <h3 class=\"card-header\" resource=\"ImportAuditInfo_Heading_Created\"></h3>\n            <div>${importEntry.created | timestamp} - ${importEntry.createdBy}</div>\n        </div>\n    </div>\n</template>\n";
// Exports
export default code;